module.exports = __webpack_public_path__ + "img/branding-logo-huisstijl-kleurenpallet-apotheek-rodenbach-machelen-zulte-3.361bd78c.jpg";